<template>
  <AuIcon
    v-if="availableThemes.length > 1"
    :icon="isLightTheme ? 'moon' : 'sun'"
    :clickable="true"
    @click="switchTheme"
  />
</template>

<script>
import localStorageController from "@/help/localStorageController";

import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      isLightTheme: "isLightTheme"
    }),

    availableThemes() {
      return process.env.VUE_APP_AVAILABLE_THEMES
        ? process.env.VUE_APP_AVAILABLE_THEMES.split(",")
        : ["light", "dark"];
    }
  },

  methods: {
    switchTheme() {
      this.$store.dispatch("switchTheme");
      localStorageController.setIsLightTheme(this.isLightTheme);
      localStorageController.setUserMadeChoice();
    }
  }
};
</script>

<style lang="scss" scoped>

</style>